export const LEGACY_SOUTH_SHORE_CITY_ID = 'bridgewater'
export const SOUTH_SHORE_CITY_ID = 'southshore'
export const ANNAPOLIS_VALLEY_CITY_ID = 'annapolisvalley'

export function normalizeCityId (cityId) {
  if (!cityId) return cityId
  return cityId === LEGACY_SOUTH_SHORE_CITY_ID ? SOUTH_SHORE_CITY_ID : cityId
}

export function isLegacyCityRouteId (cityId) {
  return cityId === LEGACY_SOUTH_SHORE_CITY_ID
}

export function cityIdReadSet (cityId) {
  const canonical = normalizeCityId(cityId)
  if (canonical === SOUTH_SHORE_CITY_ID) {
    return [SOUTH_SHORE_CITY_ID, LEGACY_SOUTH_SHORE_CITY_ID]
  }
  return [canonical]
}

export function normalizeCityRecord (city) {
  if (!city) return city
  if (
    city.id === LEGACY_SOUTH_SHORE_CITY_ID ||
    city.slug === LEGACY_SOUTH_SHORE_CITY_ID
  ) {
    return {
      ...city,
      id: SOUTH_SHORE_CITY_ID,
      slug: SOUTH_SHORE_CITY_ID,
      name: city.name || 'South Shore'
    }
  }
  return city
}

export function scheduleKeyToSouthshore (value) {
  if (typeof value !== 'string') return value
  return value.replace(/^bridgewater_/, 'southshore_')
}

export function scheduleKeyToBridgewater (value) {
  if (typeof value !== 'string') return value
  return value.replace(/^southshore_/, 'bridgewater_')
}
